import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // ✅ to get current path
import { getAboutUs } from "services/dynamicpage/dynamicpage";
import BannerSkeleton from "components/skeleton/BannerSkelaton";
import "./AboutUs.scss";


const AboutUs = () => {
  const [loading, setLoading] = useState(true);
  const [aboutData, setAboutData] = useState(null);
  const location = useLocation(); // ✅ gives current route like /about-us

  useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await getAboutUs({ path: location.pathname });
      if (res?.code === 200) setAboutData(res.data);
      else console.error("Failed to fetch About Us page");
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, [location.pathname]);


  if (loading) return <BannerSkeleton />;
  if (!aboutData) return <p
  className="error-text text-center"
  style={{
    height: "calc(100vh - 408px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: 0,
  }}
>
  No data available
</p>

  return (
    <div className="aboutus-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="about-container">
          <h1>{aboutData.PageName}</h1>
          <p className="meta-description">{aboutData.MetaDescription}</p>
        </div>
      </section>

      {/* Description & Image Section */}
      <section className="description-section container">
        <div className="content">
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: aboutData.Description }}
          />
         
        </div>
      </section>

     

    
    </div>
  );
};

export default AboutUs;
